import type { ChallengeConfig } from './types';

export const DEFAULT_CHALLENGE_CONFIG: ChallengeConfig = {
  minIntervalMinutes: 2,
  maxIntervalMinutes: 5,
  firstChallengeMinMinutes: 0,
  firstChallengeMaxMinutes: 1,
  timeoutSeconds: 15,
  maxConsecutiveFailures: 3,
};

export const HEAD_YAW_THRESHOLD = 25;

export const PITCH_UP_THRESHOLD = 15;

export const PITCH_DOWN_THRESHOLD = 50;

export const EYE_CLOSED_THRESHOLD = 0.15;

export const EYE_OPEN_THRESHOLD = 0.25;

export const MOUTH_OPEN_THRESHOLD = 0.3;

export const MOUTH_HOLD_DURATION_MS = 500;

export const WARM_UP_MS = 3000;

const MEDIAPIPE_BASE = `${process.env.PUBLIC_URL}/mediapipe`;

export const MEDIAPIPE_CDN = MEDIAPIPE_BASE;

export const MEDIAPIPE_MODELS = {
  faceLandmarker: `${MEDIAPIPE_BASE}/face_landmarker.task`,
  handLandmarker: `${MEDIAPIPE_BASE}/hand_landmarker.task`,
};
